import api from './api'

export default {
  findByUid(uid) {
    return api.get(`/chips/find-by-uid/${uid}`)
  },
}
